module.exports = __webpack_public_path__ + "static/media/mini.25c8ac6a.png";


//////////////////
// WEBPACK FOOTER
// ./src/marketingOnline/data/carImages/远程锋锐F3E平板车/mini.png
// module id = 699
// module chunks = 0